import { MAIN_AUTH, SER_CON_AGENTS_URL } from '~/src/params';
import { createLink } from '~/src/helpers/create-link.helper';
import { NavItemsEnum } from '~/src/models/enums/nav-items.enum';
import { ProfileLinkCategoryEnum } from '~/src/models/enums/profile-link-category.enum';
import type { TargetType } from '~/src/models/types/target.types';

export interface NavItem {
    id: number;
    href: string;
    label: string;
    navigate?: boolean;
    targetBlank?: boolean;
    target?: TargetType;
    children?: NavItem[];
}

type ConditionKey = 'always' | NavItemsEnum;

interface InternalNavItem extends Omit<NavItem, 'children'> {
    condition: ConditionKey;
    children?: InternalNavItem[];
}

let globalId = 0;

const NAV_ITEMS: InternalNavItem[] = [
    {
        href: MAIN_AUTH,
        label: 'Главная',
        id: globalId++,
        navigate: true,
        condition: NavItemsEnum.needToMain,
    },
    {
        href: SER_CON_AGENTS_URL,
        label: 'Подписать оферту',
        id: globalId++,
        navigate: true,
        condition: NavItemsEnum.needToAddBecomeAgent,
    },
    {
        href: '/fizlicam',
        label: 'Для физлиц',
        id: globalId++,
        navigate: true,
        condition: NavItemsEnum.needToAddBecomeAgent,
    },
    {
        href: '#',
        label: 'Список лидов',
        id: globalId++,
        navigate: true,
        condition: NavItemsEnum.needToAddClientList,
        children: [
            {
                href: '/clients-request',
                label: 'Новый лид',
                id: globalId++,
                navigate: true,
                condition: NavItemsEnum.needToAddClientList,
            },
            {
                href: '/leads',
                label: 'Список лидов',
                id: globalId++,
                navigate: true,
                condition: NavItemsEnum.needToAddClientList,
            },
            {
                href: 'instruction:special',
                label: 'Как с этим работать?',
                id: globalId++,
                navigate: true,
                condition: NavItemsEnum.needToAddClientList,
            },
        ],
    },
    {
        href: '/about-products',
        label: 'Агентские продукты',
        id: globalId++,
        navigate: true,
        condition: NavItemsEnum.needToAddBecomeAgent,
    },
    {
        href: '#',
        label: 'Инструменты',
        id: globalId++,
        navigate: true,
        condition: NavItemsEnum.needToAddClientList,
        children: [
            {
                href: '/about-products',
                label: 'Агентские продукты',
                id: globalId++,
                navigate: true,
                condition: NavItemsEnum.needToAddClientList,
            },
            {
                href: '/referral-urls',
                label: 'Реферальные ссылки',
                id: globalId++,
                navigate: true,
                condition: NavItemsEnum.needToAddClientList,
            },
            {
                href: '/agents-api',
                label: 'API МТС Агенты',
                id: globalId++,
                navigate: true,
                condition: NavItemsEnum.needToAddClientList,
            },
            {
                href: 'instruction:special',
                label: 'Как с этим работать?',
                id: globalId++,
                navigate: true,
                condition: NavItemsEnum.needToAddClientList,
            },
        ],
    },
    {
        href: '#',
        label: 'Профиль агента',
        id: globalId++,
        navigate: true,
        condition: NavItemsEnum.needToSpecialPartyRole,
        children: [
            {
                href: '/profile',
                label: 'Профиль агента',
                id: globalId++,
                navigate: true,
                condition: NavItemsEnum.needToSpecialPartyRole,
            },
            {
                href: `${createLink(ProfileLinkCategoryEnum.FINANCE_AND_PAYMENTS)}`,
                label: 'Финансы и выплаты',
                id: globalId++,
                targetBlank: true,
                target: '_blank',
                condition: NavItemsEnum.needToSpecialPartyRole,
            },
        ],
    },
    {
        href: '/invite-agent',
        label: 'Приведи агента',
        id: globalId++,
        navigate: true,
        condition: NavItemsEnum.needToAddInviteAgent,
    },
    {
        href: '/partners',
        label: 'Продукты партнёров',
        id: globalId++,
        navigate: true,
        condition: 'always',
    },
    {
        href: 'https://support.mts.ru/mts_agents/',
        label: 'Поддержка',
        id: globalId++,
        targetBlank: true,
        target: '_blank',
        condition: 'always',
    },
];

const toNavItem = ({ condition, children, ...rest }: InternalNavItem): NavItem => ({
    ...rest,
    ...(children ? { children: children.map(toNavItem) } : {}),
});

export const getNavItems = (...params: NavItemsEnum[]): NavItem[] => {
    return NAV_ITEMS
        .filter(item => item.condition === 'always' || params.includes(item.condition as NavItemsEnum))
        .map(toNavItem);
};